// Imports
import React from "react"

import Helmet from "./Helmet"

const DefaultLayout = ({
    title,
    description,
    category,
    keywords,
    children,
}) => {
    return (
        <>
            <Helmet
                title={title}
                description={description}
                category={category}
                keywords={keywords}
            />

            {children}
        </>
    )
}

export default DefaultLayout
